<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="7">
        <v-card class="elevation-12">
             <v-row >
               <v-col cols="12" sm="12" md="12" class="rmpadding">
                 <v-toolbar-title align="center" class="clearfix" justify="center"><h4> Edit Profile </h4></v-toolbar-title>
               </v-col>  
               
               <v-row cols="12" sm="12" md="12" class="rmpadding lf-mr" >
                   <v-col cols="2" sm="2" md="2" class="rmpadding"> 
                   <v-avatar size="40px">
                      <img alt="Avatar" :src="notimageimage" v-if="image === baseURL+'storage/1.1' || image === baseURL+'storage/.1'">
                      <img alt="Avatar" :src="image" v-else>
                    </v-avatar>
                     </v-col> 
                     <v-col cols="4" sm="4" md="4" class="rmpadding"> 
                         <v-btn  color="blue-grey" class="ma-2 white--text" @click="$refs.files.click()">
                                Upload
                                <v-icon
                                  right
                                  dark
                                >
                                  mdi-cloud-upload
                                </v-icon>
                              </v-btn>
                      
                     </v-col> 
                 </v-row>   
            </v-row>
        
         <div v-if="getstatus === 'fail'" class="alert alert-danger" role="alert">{{message}}</div>
          <div v-else-if="getstatus === 'success'" class="alert alert-success" >
            {{message}}
          </div>  
          <v-form @submit.prevent="validate" ref="form" lazy-validation>
            <v-card-text>
                <v-row>
                <v-col cols="6">
                  <v-text-field v-model="firstname" label="Name"></v-text-field>
                        <input type="file" style="display: none" id="files"  ref="files" multiple v-on:change="handleFilesUpload()"/>
                </v-col>
            
                <v-col cols="6">
                  <v-text-field v-model="username" autocomplete="off" :rules="usernameRule" label="Username" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col >
                  <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                </v-col>
               
              </v-row>
              <v-row>
                 <v-col cols="6">
                 
                   <date-pick class="dobpicker" :format="'DD/MM/YYYY'" v-model="dob">
                        <template v-slot:default="{toggle}">
          <v-text-field  hide-details   label="DOB" @click="toggle" v-on:keyup="formatdate($event)" placeholder="DD/MM/YYYY" v-model="dob"></v-text-field>
        </template>
                      </date-pick>
                </v-col>
                 <v-col cols="6">
                  <v-select v-model="gender"  :items="genderarr" label="Gender" required></v-select>
              
                 </v-col> 
              </v-row>  
            <!-- <v-row>
                <v-col cols="6">
                
                   <v-text-field
            v-model="password"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRule"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            label="Password"
            hint="At least 6 characters"
            counter
            autocomplete="off"
            @click:append="show1 = !show1"
          ></v-text-field>
                </v-col>
             
                <v-col cols="6">
                <v-text-field
                        v-model="confirmpassword"
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="confirmpasswordRule"
                        :type="show2 ? 'text' : 'password'"
                        name="input-10-1"
                        label="Confirm Password"
                        hint="At least 6 characters"
                        counter
                        autocomplete="off"
                        @click:append="show2 = !show2"
          ></v-text-field>   </v-col>
              </v-row> -->
              <v-row>
                <v-col cols="6">
                  <v-select v-model="region" :rules="regionRule" @change="stateslist($event)" :items="regions" label="Country" required></v-select>
                </v-col>
             
                <v-col cols="6">
                   <v-autocomplete id="stateid"  @change="selectcities($event)"  :rules="stateidRule" v-model="stateid" :items="statesarr" item-text="state_name" item-value="state_id"   dense
                       filled label="State / County"  class="p-0" ></v-autocomplete>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="6">
                  <v-autocomplete id="cityid" hide-details    v-model="cityname" :items="citiesarr" item-text="city_name" item-value="city_id"   
                       filled label="City"  class="p-0" ></v-autocomplete>
                </v-col>
             
                <v-col cols="6">
                  <v-text-field v-model="suburb" label="Suburb" required></v-text-field>
                </v-col>
              </v-row> 
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Update</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';
//import { mapState } from 'vuex'
export default {
  name: "Register",
    components: {DatePick},
  data() {
    return {
     // logo: require("@/assets/logo-1.png"),
      region: "",
      regions: [],
      firstname: "",
      lastname: "",
      userid: "",
      email: "",
      username: "",
      message:"",
      getstatus:"",
      password: "",
      file: '',
       files:[],
      emailRules: [
        v => !!v || "Please enter your email address",
        v =>
          /.+@.+\..+/.test(v) ||
          "This doesn't appear to be a valid email address"
      ],
      genderarr:["Male","Female","Other"],
      gender:"",
      city:"", 
      stateid:"",
      cityname:"",
      suburb:"",
       statesarr:[],
        citiesarr:[], 
      confirmpassword:"", 
      dob:"",
        from_date: "",
      fromdate: "2022-03-09",
       passwordRule: [
       // v => v.length >= 6 || "Password must be at least 6 characters"
      ],
      confirmpasswordRule: [
       // v => v.length >= 6 || "Confirm Password must be at least 6 characters",
         v =>
          v === this.password || 'The password confirmation does not match.',
      ],
       stateidRule: [
        v => !!v || "Please Select the state."
      ],
       usernameRule: [
        v => !!v || "Please enter your username."
      ],
       show1: false,
       show2 : false, 
       regionRule: [
        v => !!v || "Select the most accurate locale so we can provide you with more relevant questions"
      ], 
     // regionRule: [
       // v => !!v || "Select the most accurate locale so we can provide you with more relevant questions"
      //]
    };
  },
  computed:{
    //  ...mapState({
    //    image:'avatar'
    //  }),
          baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }, 
             name() {
                return this.$store.getters.name;
              },
              image(){
      
       return this.$store.getters.getavatar;
    },
     },
  mounted(){
    this.getRegions();
      this.getUserData();
  },
  methods: {
     formatdate(event){
      var delimeter = "/";
       if(event.code != "Backspace")
       {
         if(this.dob.length == 2 || this.dob.length == 5)
         {
           this.dob = this.dob + delimeter;
         }
       }
       else
       {
          if(event.code == "Backspace")   
          {
             if(this.dob.length == 2)
            {
              this.dob = '';
            }
          } 
       }
    },
    getUserData() {
     
       this.$store.dispatch("retrieveUserDetails").then(() => {
             this.firstname  = this.$store.getters.getfirstname;
             this.lastname  = this.$store.getters.getlastname;
             this.email  = this.$store.getters.email;
             this.username  = this.$store.getters.getusername; 
             this.region = this.$store.getters.getregion; 
             this.dob = this.$store.getters.getDob;

             if(this.region !="")
             {
              this.stateslist(this.region);
             } 
           //  var getdob = "";
             //getdob  = require("moment")(this.dob).format("DD/MM/YYYY");
           //  this.dob = getdob;//this.$store.getters.getDob; 
             this.gender = this.$store.getters.getGender; 

             this.cityname = this.$store.getters.getCityname; 
             this.stateid = this.$store.getters.getStateid; 

               if(this.stateid !="" && this.region !="")
            {
               this.selectcities(this.stateid);
            }
             this.suburb = this.$store.getters.getSuburb; 
         });

    },
    validate() {
      if (this.$refs.form.validate()) {
        this.updateprofile();
      }
    },
    handleFilesUpload(){
        let uploadedFiles = this.$refs.files.files;
         
        for( var i = 0; i < uploadedFiles.length; i++ ){
          this.files.push( uploadedFiles[i] );
          //alert(URL.createObjectURL(uploadedFiles[i]));
          console.log(URL.createObjectURL(uploadedFiles[i]));
          this.$store.state.avatar = URL.createObjectURL(uploadedFiles[i]);
        }
      },
    updateprofile() {

      let formData = new FormData();
        
        for( var i = 0; i < this.files.length; i++ ){
          let file = this.files[i];
          formData.append('avatar', file);
        }  
        
        formData.append('firstname', this.firstname);
       // formData.append('lastname', this.lastname);
        formData.append('email', this.email);
        formData.append('region', this.region);

        formData.append('cityname', this.cityname);
        formData.append('suburb', this.suburb);
        formData.append('stateid', this.stateid);
        formData.append('password', this.password);


    //  var getdob = "";
  //  getdob  = require("moment")(this.dob).format("YYYY-MM-DD");
//alert(getdob);

        formData.append('dob', this.dob);
        formData.append('gender', this.gender);
        formData.append('username', this.username);
        


      this.$store
        .dispatch("editprofile", formData)
        .then(response => {
          console.log(response);
         // this.$router.push({ name: "login" });
            this.getstatus =  localStorage.getItem('response_status');// this.$store.getters.geteditProfileMessage.status;
            this.message =  localStorage.getItem('response_message');// this.$store.getters.geteditProfileMessage.message;
           
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("logging error from login");
          console.log(error);
        });
    },
    getRegions(){
      this.$store.dispatch("retriveRegions").then(() => {
           this.regions = this.$store.getters.getregions;
      });
    },
      stateslist(getcountry)
    {
    
       this.$store
        .dispatch("stateslist", {
          countryname: getcountry,
        })
        .then(response => {
          this.statesarr = response.data;
          console.log(response.data);
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log("cities error from rigister");
          console.log(error);
        });
    },
     selectcities(getstate)
    {
    
       this.$store
        .dispatch("citieslist", {
          stateid    : getstate,
          countryname: this.region,
        })
        .then(response => {
          this.citiesarr = response.data;
        })
        .catch(error => {
          // TODO: handle incorrect login
          console.log(error);
        });
    },
  }
};
</script>

<style scoped>
.row {
  margin-left: 0px;
}
.rmpadding{padding:0px !important;}
.clearfix{clear: both;margin-bottom:15px;}
.alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
.alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
}
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    margin-top:28px;
}
.lf-mr{margin-left:10%;}
</style>